import React, {Component} from 'react';
import withMyCoordsHOC from "./MyCoordsHOC";
import {distanceFromCoords} from "../utils/DistanceFromCoords";

class DistanceFromMe extends Component {
    render() {
        if (
            this.props.lat && this.props.lng &&
            this.props.myCoords.lat && this.props.myCoords.lng
        ) {
            return (
                <div>
                   {
                    Math.ceil(distanceFromCoords(
                        Number(this.props.lat),
                        Number(this.props.lng),
                        Number(this.props.myCoords.lat),
                        Number(this.props.myCoords.lng),
                    ) * 1.15)
                    } km
                </div>
            )
        } else {
            return (
                <div>
                    Ismeretlen
                </div>
            )
        }
    }
}

export default withMyCoordsHOC(DistanceFromMe)